export default "__VITE_ASSET__CozZA4oO__"